module.exports = "<div data-template> <div class=voc-live-scribble-item> <div class=voc-live-scribble-author> {% if Creator.Avatar.length > 0 %} <img src={{Creator.Avatar}} class=figure-author alt=\"\"> {% endif %} {% if Creator.Avatar.length == 0 %} <i class=\"voc-services nothing\"></i> {% endif %} </div> <p class=voc-live-scribble-date>{{FormattedDate}}</p> <div class=voc-live-scribble-content> <p class=author-name>{{Creator.Name}}</p> <p class=voc-description>{{Content}}</p> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/templates/content.html
// module id = 6
// module chunks = 0